// Mock data for PEC STUDIOS Real Estate Editing Service - WITH REAL IMAGES

export const companyInfo = {
  name: "PEC STUDIOS",
  tagline: "You Imagine It. We Create It.",
  email: "pecstudios.media@gmail.com",
  phone: "+918527302142",
  location: "New Delhi, India"
};

// Helper function to convert Google Drive links to thumbnail URLs
const gdrive = (id) => `https://drive.google.com/thumbnail?id=${id}&sz=w2000`;

export const heroCarouselImages = [
  {
    before: gdrive("19slrhn8LT18CQvXsv_JZ2hJKH0VDwJVa"),
    after: gdrive("1sAju-hnvDfVb9ufgt2Szk7ct3-W9rLqH"),
    service: "HDR IMAGE EDITING",
    title: "Stunning Interior Enhancement"
  },
  {
    before: gdrive("1B3YtDcVHctfJaNfPEA6XSPElwhFd3RPv"),
    after: gdrive("1CMDoUQRkJLZ8PFwJfqdod4w2g-4BDphW"),
    service: "DAY TO DUSK CONVERSION",
    title: "Dramatic Twilight Transformation"
  },
  {
    before: gdrive("1_5nfumVe5xVnXm73VPVTyhucdqL4UUjw"),
    after: gdrive("1oBSbSdrIeRD-byUKInjA-XeJTAHaHH8h"),
    service: "VIRTUAL STAGING",
    title: "Empty Space to Dream Home"
  },
  {
    before: gdrive("18ul0m-35zvnGM87orde5R7Z8wnzUL0H4"),
    after: gdrive("1pnOKAHkGQmZ14w2DPOujrhnWNIB9Xexg"),
    service: "FLAMBIENT EDITING",
    title: "Perfect Interior Lighting"
  }
];

export const services = [
  {
    id: "flambient",
    title: "Flash / Flambient Editing",
    icon: "Zap",
    shortDesc: "Blend ambient and flash photography for perfectly lit interiors that look natural and inviting.",
    fullDesc: "Our flambient technique combines flash and ambient light photos to create beautifully lit interior shots that maintain natural warmth while eliminating harsh shadows.",
    features: [
      "Flash and ambient blending",
      "Shadow elimination",
      "Natural lighting balance",
      "Color temperature correction"
    ],
    images: [
      { before: gdrive("18ul0m-35zvnGM87orde5R7Z8wnzUL0H4"), after: gdrive("1pnOKAHkGQmZ14w2DPOujrhnWNIB9Xexg"), title: "Living Room" },
      { before: gdrive("1AkVFJpBJK6rUEIX3928TmlYI5CcSx-uf"), after: gdrive("1cuYJVB18lXQnEZhsyPp6a15BZ1EmhZe2"), title: "Kitchen" },
      { before: gdrive("16WdbuTQPFZiAygOGbHeta8TtdSGBRvbo"), after: gdrive("1e-NFsOSkvxtPhIGI1qY2sMK0FPTyeWlO"), title: "Bedroom" },
      { before: gdrive("1VLTOEOsitSjR5jEw4OQJW0Urf3l3FtPf"), after: gdrive("11BbN4ZsNbXoCyygx8L_QwK-ZLXhAsxp0"), title: "Dining Room" },
      { before: gdrive("1qD8Qlxv8Yv_hwt3KGdowHnHO-Mr5ZPPd"), after: gdrive("1WIqpw6bBUsdczqqJdeFX8joga94Mo4Hn"), title: "Master Suite" },
      { before: gdrive("1Y8i5Yc4Tnu2CUXzAwnGpYQkZrzrVCH8s"), after: gdrive("1VFEX5xVBYpE-uFpSf9pdx3OVFnxli9rV"), title: "Bathroom" },
      { before: gdrive("1XKvSUbivo6V0EHKcW1a2Y6JIrxA2tm5r"), after: gdrive("1kVbMtCy9RehvEln-S-DWrAnT3S1NSwZ9"), title: "Office Space" },
      { before: gdrive("1Gmai27EKq413c6I9nHiXAdqUiUIK1IBI"), after: gdrive("1qM_dEdK8M3IZNvj7KF-3VIo0q_OqfnYe"), title: "Family Room" }
    ]
  },
  {
    id: "hdr",
    title: "HDR Image Editing",
    icon: "Camera",
    shortDesc: "Perfectly balanced exposures bringing out details in highlights and shadows for stunning real estate photos.",
    fullDesc: "Our HDR editing combines multiple exposures to create perfectly balanced real estate images. We manually blend each photo to ensure natural-looking results that showcase properties in their best light.",
    features: [
      "Multiple exposure blending",
      "Natural color correction",
      "Detail enhancement",
      "Window pull processing"
    ],
    images: [
      { before: gdrive("19slrhn8LT18CQvXsv_JZ2hJKH0VDwJVa"), after: gdrive("1sAju-hnvDfVb9ufgt2Szk7ct3-W9rLqH"), title: "Luxury Living Room" },
      { before: gdrive("1v0WLuJXy34H1uVsXZksqZKi2sGcpvHDH"), after: gdrive("1wmtWekA9PqVV48ZvN_3sOZuHJRXpGqui"), title: "Modern Kitchen" },
      { before: gdrive("1Ou2NEisfLHv0gj7kdvEQRhe42WbmKm50"), after: gdrive("1WgZZXfPJoz8k85KLJKKuZvmpB6rUaYJG"), title: "Master Bedroom" },
      { before: gdrive("19T-dBViCutCUnIubumdoMOr0cqfnoi0A"), after: gdrive("10BDi4Fw7LlZE0sOi2URdReXfmDQWId-v"), title: "Dining Area" },
      { before: gdrive("1Ek5WG4CJA8Jfb6wucciZQfd8N4tjjctG"), after: gdrive("1RtnQUcfGQooTlXickqXe0n57yEZplWMf"), title: "Bathroom" },
      { before: gdrive("1OwsB-FEdyBA9YhNOBXUa0VVj81sSr9fh"), after: gdrive("10B1IE_V1i9psKq7khSPmJDFiMHbX19J4"), title: "Home Office" },
      { before: gdrive("1daH5aAoqf5aJUEEfuVjKf5vUyjJ7Cyhi"), after: gdrive("1X4xEUUXKC1N5KnwCYQfeIka2FpU1bZ5e"), title: "Living Space" },
      { before: gdrive("12SRdknSNyIcPCUPJ8erFgSQVl8Z1qK9u"), after: gdrive("12Hv--mptvrtY-Z0zazHYGfMsZ0JAIdiU"), title: "Entertainment Room" },
      { before: gdrive("1caCKqZ3-gDZBLtYODT2t-3TUsyd6-2kJ"), after: gdrive("1qVbOMDPS6-jHlUorDT2FNsFjt29bBoBy"), title: "Guest Room" },
      { before: gdrive("16xVXvqd5cjoTLWhBIIX3oq4QezXkiUL3"), after: gdrive("10h0-RnEGdBBgZoQkoX0TCZVCFrgKd-EF"), title: "Study Area" }
    ]
  },
  {
    id: "single",
    title: "Single Image Editing",
    icon: "Image",
    shortDesc: "Professional retouching and color correction for single real estate images with attention to every detail.",
    fullDesc: "Transform your single property photos with professional editing that includes color correction, brightness adjustment, and detail enhancement while maintaining a natural, realistic look.",
    features: [
      "Color correction",
      "Brightness optimization",
      "Contrast adjustment",
      "Noise reduction"
    ],
    images: [
      { before: gdrive("1yyAx7INgAaSDzHhApH7HEPtbr0pbXMoq"), after: gdrive("1eRDMZn6rSnJEgHXVM3kkOrYshRC-DaTs"), title: "Living Room" },
      { before: gdrive("18mGIz_gxrJGV9Z9H-lkwrt0rnStAwFde"), after: gdrive("1-I2pEduhqPxpgSiJ5TKh34IFGm1qotdC"), title: "Kitchen" },
      { before: gdrive("1j4Anx0EKOp49V_2lLw2rpJIIrFQqvHli"), after: gdrive("1m6YBy4cFHJ31HX26scVWPA82dG7UzFss"), title: "Bedroom" },
      { before: gdrive("13bUPd5u9b2zWf6DzxaK2My-vQJrpGp19"), after: gdrive("1IBasWEJ-n3FghHrcLmMu3OXaCOP06qDv"), title: "Bathroom" },
      { before: gdrive("1oPD5pQcOu8aJV3TD76GAqQc9YLas1stW"), after: gdrive("1AWNy0BlGubcyNJxjX12NT4pdPIM83_wr"), title: "Dining Room" },
      { before: gdrive("16hZ8gv2ewC0gbroM8fIKU10lbYP4eraZ"), after: gdrive("1QLfnBIt1OMxU8dII_uwp7RC_Ee4hhZRS"), title: "Office" },
      { before: gdrive("1eno3GBwDT4kS9cLmTY0xTGY--ldOyGWy"), after: gdrive("1vJLfxnaPpnaBvlANgU6FlT9NHc-q9c32"), title: "Family Room" },
      { before: gdrive("1rlvyoFGxIGaDgTx2qtKFTLRG03R6AmWN"), after: gdrive("1NH1Ecdq5BDXT-BQ1oGH_eVpejvFwHLIo"), title: "Game Room" },
      { before: gdrive("1NX7UVx3Ev5oA7niY2XssJPVvMyiIFvt-"), after: gdrive("1sFYViXb00KE5Ey-OpcMYqALVvMGpJX6x"), title: "Laundry Room" },
      { before: gdrive("1NgNETpRJystcfo1l3gi0y3bIJmfpeUZ2"), after: gdrive("1P0IzQwpbObQPvTEBxrL6WcngzhAf8kph"), title: "Basement" },
      { before: gdrive("13Bf_Im-AfvFG1ARGQRKQ5mQBA4Nfn5lH"), after: gdrive("11v_ogviVtV2x3XNmhbzBvQ-SMB5_avVN"), title: "Entryway" },
      { before: gdrive("1ChTEsVaMtVXUXnSlKG1eWtXSDMuy0I3S"), after: gdrive("1CmAMRJqTmGHC9CYXpPerfgItkLaqJegc"), title: "Hallway" },
      { before: gdrive("1bG93N5OE7HRqLcN_PqZEsQzdhyAZpJvo"), after: gdrive("1vUQ_qnSCT2T6_NIq282zG3E6q0DiyNl7"), title: "Closet" }
    ]
  },
  {
    id: "video",
    title: "Real Estate Video Editing",
    icon: "Video",
    shortDesc: "Professional video editing for property tours, drone footage, and cinematic walkthroughs.",
    fullDesc: "Elevate your property marketing with professional video editing. We create engaging property tours, edit drone footage, and produce cinematic walkthroughs that captivate viewers.",
    features: [
      "Property tour editing",
      "Drone footage editing",
      "Color grading",
      "Music and transitions"
    ],
    images: []
  },
  {
    id: "staging",
    title: "Virtual Staging",
    icon: "Sofa",
    shortDesc: "Furnish empty rooms with realistic virtual furniture to help buyers visualize the space\'s potential.",
    fullDesc: "Transform vacant properties with photorealistic virtual furniture. Our staging helps buyers see the full potential of empty spaces, increasing interest and offers.",
    features: [
      "Multiple style options",
      "Photorealistic furniture",
      "Custom layouts",
      "Fast turnaround"
    ],
    images: [
      { before: gdrive("1_5nfumVe5xVnXm73VPVTyhucdqL4UUjw"), after: gdrive("1oBSbSdrIeRD-byUKInjA-XeJTAHaHH8h"), title: "Living Room Staging" },
      { before: gdrive("1itg4lEEUJ3TDQ8hQLxpqBeped_3_eEBX"), after: gdrive("1Vc-wPAylba3ZWDcJlbKgLHac1MDVvcAy"), title: "Bedroom Staging" },
      { before: gdrive("1K92L9bkpnK6kQ7z7R7LR_Ztu6IEFOb8v"), after: gdrive("1d9NVLwjuF3xSAJ7z1zkLRaC90B0oZOfM"), title: "Dining Room Staging" },
      { before: gdrive("16gUzHn3JnkNfOTSycR-AehhrIuVFrzAW"), after: gdrive("12yqf4S-MwOMDuBExANoRtSQdRDuSEnaI"), title: "Office Staging" },
      { before: gdrive("18cVp00Xz-5EhkQuPkR2UvA96RjIEwCnr"), after: gdrive("1db6Sl2te-F7cuTEz6VZ_UEyFiqAHemCv"), title: "Master Suite" },
      { before: gdrive("197J71rJ7uiJdutLEyfv8pwyDvTjwZdsX"), after: gdrive("1cSvxrI2u11QtLtw1IqXbKXBHY7mtYdfb"), title: "Family Room" },
      { before: gdrive("11amoI3HFLg1DCZTA-cfRDSMnaNseCA5y"), after: gdrive("1hR8h-D3NDOYMuafetRR9P4lLL3LgVoxX"), title: "Guest Room" },
      { before: gdrive("1XfRU1aQtTO0x5dX-lIsyzX20EEuwJvRa"), after: gdrive("1eNVgdabUGHCLoDpsV1vN9i8I5fXMpSRf"), title: "Playroom" },
      { before: gdrive("1zjcXr6XnS5if3yWnCMtYS00m9Kw9ZOn0"), after: gdrive("1garj6s196Bxp5hgnktbUXfFi583qVTEo"), title: "Basement" },
      { before: gdrive("1dpHmC5dXt1ZJci8Bk_UHhEQ1xDAai7fF"), after: gdrive("1n55-byS4h1gEpDZocGiJi0p4CuqIkd7y"), title: "Loft Space" },
      { before: gdrive("1_u9yVtEY5GBWNlSqYCK6iN2QjmIoG-mC"), after: gdrive("1ZTLJ1PQ3oeWIFQL8hdURYbsvX5Wq9sUD"), title: "Studio Apartment" }
    ]
  },
  {
    id: "twilight",
    title: "Day to Dusk / Twilight",
    icon: "Sunset",
    shortDesc: "Transform daytime photos into stunning twilight shots that make properties stand out in listings.",
    fullDesc: "Create dramatic twilight images from daytime photos. Our day-to-dusk editing adds warm interior lighting and beautiful sky replacements for maximum curb appeal.",
    features: [
      "Sky replacement",
      "Interior light enhancement",
      "Landscape lighting",
      "Color grading"
    ],
    images: [
      { before: gdrive("1B3YtDcVHctfJaNfPEA6XSPElwhFd3RPv"), after: gdrive("1CMDoUQRkJLZ8PFwJfqdod4w2g-4BDphW"), title: "Exterior Twilight 1" },
      { before: gdrive("1Exlvn13TxqmhgqwWky1C1OCiHjFPc5Yd"), after: gdrive("1XcrPaDPf3apjtXRtk1lYI-JcSg0-OCFo"), title: "Exterior Twilight 2" },
      { before: gdrive("19dhC4w1-hbhcAeFeEV1OtGjhx3egC1EO"), after: gdrive("1UIOYqQSTqgCsJjmq2-A_GRyR79itjslM"), title: "Front Facade" },
      { before: gdrive("1ys09B3X7wltupkQpX_6plUsslgWPlEQR"), after: gdrive("1ldWKnS34C7IWLGU31hrmtput34MWr77I"), title: "Backyard View" },
      { before: gdrive("1s--OTfJx5GpY6eEg6WZ166ILg1wW2VAC"), after: gdrive("1Y7x7gf-WSLhpGBvunA55jzenpTXlwfoO"), title: "Pool Area" },
      { before: gdrive("1EWC022hEmprmcf8febl383OLaVPQ6o7g"), after: gdrive("1owY4iBTMJ4mwjnE9oLwwcJomu-n0Yo_s"), title: "Street View" },
      { before: gdrive("1DEQHbDKsYYoIq2xyMKUwNHe84K6TrGmO"), after: gdrive("16u0-MiVbBt_89NqIwSA3Np4NBdzQ7RCv"), title: "Driveway" },
      { before: gdrive("15lnVuQfGBY51rMNkD5MLnB7stOlsAPZT"), after: gdrive("1Le2kSqLQB7_IS2WNHZcTGcHcmp2KV--T"), title: "Garden" },
      { before: gdrive("1KMRY1vKn7ydElh8u3a4kkc6DqsYPn9Mn"), after: gdrive("1hyqLInFiGoytAO5vumjbhkh_jOWDX7Qo"), title: "Patio" },
      { before: gdrive("1ztmDYmRhHnvtKn6A28Tqi3tshS_yytIW"), after: gdrive("1CvwRsWqVdAZzJ5IbMVCfUGje86nQNjtc"), title: "Entrance" },
      { before: gdrive("1kAeyKxXdcw--8dB2B0pvgM10GbFioeXO"), after: gdrive("1k594Pp9BBakMYGooN01pzNCNOJ02wOoc"), title: "Side View" },
      { before: gdrive("1MrXCEleHYpK12lZKR3rXWMDdIX1NZkWj"), after: gdrive("14SUYoWlwhen6sG6pOybBGLbI1bzv_FFs"), title: "Corner Lot" },
      { before: gdrive("1muuxts_Nc0gHjLf7HY5z5ndElyqdpN8X"), after: gdrive("1M8kgdGDzAzO_jVBEIoG40MT66AEAFl8R"), title: "Estate View" },
      { before: gdrive("1dd17LfBXaPmXnSWtApvzq9rQIpgLWkO3"), after: gdrive("1cj6mw6K4Hwyqj2dkH6GaVMqvK0_kJO2g"), title: "Luxury Home" }
    ]
  },
  {
    id: "removal",
    title: "Item Removal",
    icon: "Trash2",
    shortDesc: "Remove unwanted objects, vehicles, or clutter from property photos for clean, professional results.",
    fullDesc: "Clean up your property photos by removing distracting elements. From cars and trash bins to personal items, we\'ll make your listings look pristine.",
    features: [
      "Object removal",
      "Clutter cleanup",
      "Power line removal",
      "Seamless patching"
    ],
    images: [
      { before: gdrive("1w_UwC8Giu22ijjIdL6A4ped8dr-IJITW"), after: gdrive("1QkMoTu9WjN3-iztD9pKK8lS8VnAHR6yn"), title: "Vehicle Removal" },
      { before: gdrive("1gm0jaTC_yURADH1k-zKGFt68dedC2pwg"), after: gdrive("1uBfAOM7ksRaMpsogv2l8YKp814V_DoHE"), title: "Clutter Cleanup" },
      { before: gdrive("1nbuK-gsbKv6uy0Vw0M9xjCJpVVaGkD8D"), after: gdrive("1bv_l3eSIvzgwh1MPWoMRMlvpToVlu0WT"), title: "Power Lines" },
      { before: gdrive("14grokUVYhj1MAXgOkEmxOyzdTiYdl_gC"), after: gdrive("1Q8jQx1QnuNsJP8FYA_o6Pe1UmJ4RpUO3"), title: "Trash Bins" },
      { before: gdrive("1gDtdWxDsduMzJfhm9ibNOmUtzGwMcqHc"), after: gdrive("1sUUQpxfBryjIPhRdhROr0WFqgDfE22iS"), title: "Personal Items" },
      { before: gdrive("163BQHTT78c9lG4_5Pu7cylxq3IfkHDpW"), after: gdrive("1vFjX8FwnHnPNJNMMGO-vDsvkqrpD-1yD"), title: "Furniture" },
      { before: gdrive("1aPZSMHoZ_-z-Pl0HtgKl5GrPtHJj8SQ0"), after: gdrive("1wcLY8HhDrafGOXqGlB-Hk6IMQBgvY4JP"), title: "Signs" },
      { before: gdrive("1GCQSFe2DQiOCtxO9PM9SIGzLW0wZEDma"), after: gdrive("1ayJbtPkDUC5Ed3ChdGf2OGkpqFM1lqK7"), title: "Equipment" },
      { before: gdrive("1u4r8f3q1MY7NWo64FogdZDw3u6rp7WtF"), after: gdrive("1vHZivdDyXMPQR9B5LZy4EFGJELATblRe"), title: "Cables" },
      { before: gdrive("1m21Yc2dTCUhScJo6sNNGu_AuLwdlLmsq"), after: gdrive("1kUNhMfSsjC476jwGX0dcP2ZeAK-HtPo9"), title: "Boxes" },
      { before: gdrive("1oFMnU40_K0jPj_d6JwVG_FJiE_q5rDw_"), after: gdrive("190vPSbJXgOKKg6SfEighDfUe_6YxCPVM"), title: "Outdoor Items" },
      { before: gdrive("1EAXLFnC3hRdoLO-h7ytutcAAZIEFaezn"), after: gdrive("1Jkn_lDtPf6Uo2pmIVtM7s20JWTO-x-ev"), title: "Tools" },
      { before: gdrive("1n45wEjxiTtqryTj27xeLUnSdQ_vxuelC"), after: gdrive("1u2eMrad5Yr8fbvAgVRVnqKX7xQWgODjr"), title: "Debris" },
      { before: gdrive("1MzK8-1W5P-VZi33nJ8XQBf_j5SBRBy5L"), after: gdrive("1V4XW3JZ39w9IsZmPNyIaBrd6OSe_UV5n"), title: "Yard Waste" },
      { before: gdrive("1gFAkqk4LrM76TRC3Ih7BwWygpQ91ZoPr"), after: gdrive("1pMJnH3rn1BOoOP-Zt0EtKIAu_AazEdj1"), title: "Construction Materials" },
      { before: gdrive("1XU32U9yEd8L2m3BeONshAPx90oMPTbNc"), after: gdrive("1YT_2S1RQSmEivM17XELy1Yd0CdDNabrV"), title: "Misc Objects" }
    ]
  }
];

export const whyChooseUs = [
  {
    icon: "Clock",
    title: "Fast Turnaround",
    description: "8-16 hour delivery on most services. Up to 48 hours for virtual staging and video editing."
  },
  {
    icon: "Eye",
    title: "Natural & Realistic",
    description: "Our editing enhances properties while maintaining a natural, realistic look buyers trust."
  },
  {
    icon: "Award",
    title: "Consistent Quality",
    description: "Professional results every time. Our experienced team ensures consistency across all your listings."
  },
  {
    icon: "DollarSign",
    title: "Affordable Pricing",
    description: "Competitive rates without compromising quality. Volume discounts available."
  },
  {
    icon: "Globe",
    title: "Global Clients",
    description: "Trusted by photographers and agencies worldwide from USA, UK, Canada, Australia, and Europe."
  },
  {
    icon: "Shield",
    title: "Secure & Confidential",
    description: "Your images are safe with us. Secure file transfer and strict confidentiality guaranteed."
  }
];

export const portfolioCategories = services.map(service => ({
  id: service.id,
  name: service.title,
  images: service.images
}));

export const testimonials = [
  {
    name: "Sarah Johnson",
    role: "Real Estate Photographer, California",
    text: "PEC STUDIOS has been my go-to editing service for over 2 years. Their HDR editing is phenomenal and the turnaround time is unbeatable.",
    rating: 5
  },
  {
    name: "Michael Chen",
    role: "Property Marketing Agency, Toronto",
    text: "The virtual staging service has helped us sell vacant properties 40% faster. Highly recommend their professional service.",
    rating: 5
  },
  {
    name: "Emma Williams",
    role: "Luxury Real Estate Broker, London",
    text: "Quality is consistently excellent. Their twilight shots make our luxury listings absolutely stunning.",
    rating: 5
  }
];

export const pricingPlans = [];

// Editing process steps for each service
export const editingProcessSteps = {
  twilight: {
    title: "Our 9-Step Day to Dusk Process",
    steps: [
      "Sky Replacement",
      "Lawn Replacement or Enhancement",
      "Removing Chromatic Aberration",
      "Color correction / White Balance",
      "Removing Dust / Sunspots",
      "Blending multiple Exposures",
      "Turn on Lights",
      "Straightening of vertical and horizontal lines",
      "Lens Distortion Removal"
    ]
  },
  flambient: {
    title: "Our 17-Step Flash/Ambient Image Enhancement Process",
    steps: [
      "Color correction",
      "Brightness & contrast adjustments",
      "Blending multiple Exposures",
      "Lawn Replacement or Enhancement",
      "Sky Replacement",
      "Removing Chromatic Aberration",
      "Window Masking",
      "Color correction / White Balance",
      "Flash and Shadow Removal",
      "Correcting Verticals & Horizontal Straightening",
      "Replace burnt out light bulbs",
      "Removing Dust / Sunspots",
      "Object Removal (Messy Electrical Cords)",
      "Removing pool cleaner / Changing pool color",
      "Adding an image on the TV screen",
      "Add fireplace on any type",
      "Enhancing details, exposure & contrast"
    ]
  },
  hdr: {
    title: "Our 17-Step HDR Photo Enhancement Process",
    steps: [
      "Color correction",
      "Brightness & contrast adjustments",
      "Blending multiple Exposures",
      "Lawn Replacement or Enhancement",
      "Sky Replacement",
      "Removing Chromatic Aberration",
      "Window Masking",
      "Color correction / White Balance",
      "Flash and Shadow Removal",
      "Correcting Verticals & Horizontal Straightening",
      "Replace burnt out light bulbs",
      "Removing Dust / Sunspots",
      "Object Removal (Messy Electrical Cords)",
      "Removing pool cleaner / Changing pool color",
      "Adding an image on the TV screen",
      "Add fireplace on any type",
      "Enhancing details, exposure & contrast"
    ]
  },
  removal: {
    title: "Our 5-Step Item Removal Process",
    steps: [
      "Remove furniture from the room",
      "Creative photo manipulation",
      "Enhancing and retouching of photos",
      "Removing Chromatic Aberration",
      "Color correction / White Balance"
    ]
  },
  single: {
    title: "Our 15-Step Still Image Enhancement Process",
    steps: [
      "Color correction",
      "Brightness & contrast adjustments",
      "Lawn Replacement or Enhancement",
      "Sky Replacement",
      "Removing Chromatic Aberration",
      "Color correction / White Balance",
      "Flash and Shadow Removal",
      "Correcting Verticals & Horizontal Straightening",
      "Replace burnt out light bulbs",
      "Removing Dust / Sunspots",
      "Object Removal (Messy Electrical Cords)",
      "Removing pool cleaner / Changing pool color",
      "Adding an image on the TV screen",
      "Add fireplace on any type",
      "Enhancing details, exposure & contrast"
    ]
  },
  video: {
    title: "Our 14-Step Video Editing Process",
    steps: [
      "Project Brief & Requirement Analysis",
      "Media Ingest & Backup",
      "File Organization & Naming",
      "Footage Review & Selection",
      "Timeline Setup & Sequence Settings",
      "Rough Cut Assembly",
      "Fine Cut & Precision Editing",
      "Story Pacing & Flow Optimization",
      "Audio Editing & Cleanup",
      "Audio Mixing & Music Sync",
      "Color Correction",
      "Color Grading",
      "Effects, Transitions & Motion Graphics",
      "Titles, Captions & Final Polish"
    ]
  },
  staging: {
    title: "Our 8-Step Virtual Staging Process",
    steps: [
      "Image Review & Selection",
      "Basic Image Cleanup",
      "Perspective & Alignment",
      "Furniture Selection (Staging Plan)",
      "3D Placement of Furniture",
      "Lighting & Shadow Matching",
      "Color & Texture Blending",
      "Realism Enhancement"
    ]
  }
};

// Service descriptions for the landing page
export const serviceDescriptions = {
  flambient: "Our Flash/Ambient editing technique combines flash and ambient light photographs to create beautifully lit interior shots. By expertly blending multiple exposures, we eliminate harsh shadows while maintaining the natural warmth and character of each room. The result is perfectly balanced interior images that showcase properties in their most inviting and natural light.",
  hdr: "Our HDR (High Dynamic Range) editing process combines multiple exposures to create perfectly balanced real estate images. We manually blend each photograph to bring out rich details in both highlights and shadows, ensuring every corner of the room is visible while maintaining a natural, realistic look that attracts potential buyers.",
  single: "Our Single Image editing service transforms individual property photographs with professional color correction, brightness optimization, and detail enhancement. Every image receives meticulous attention to ensure natural-looking results that make properties shine. Perfect for photographers who need quick, high-quality edits for their real estate listings.",
  video: "Elevate your property marketing with our professional video editing service. We transform raw footage into engaging property tours, cinematic walkthroughs, and stunning drone sequences. Our editors specialize in smooth transitions, professional color grading, and audio mixing that create an immersive viewing experience for potential buyers.",
  staging: "Transform empty rooms into beautifully furnished living spaces with our photorealistic Virtual Staging service. Using advanced 3D rendering, we place realistic furniture and decor that perfectly matches the style and proportions of each room. Our staging helps buyers visualize the full potential of vacant properties, leading to faster sales.",
  twilight: "Our Day to Dusk conversion transforms ordinary daytime property photos into dramatic twilight masterpieces. By replacing skies, adding warm interior lighting, and applying professional color grading, we create stunning images with maximum curb appeal that make your listings stand out from the competition.",
  removal: "Our Item Removal service cleans up property photos by expertly removing unwanted elements. From vehicles and trash bins to personal items and power lines, we digitally erase distracting objects while seamlessly reconstructing the background. The result is clean, professional images that let the property speak for itself."
};
